import { getListaDeEtiquetas } from '../../../../../models/movimiento/dropdownEtiquetas/dropdownService'

export function actualizarDropdown (cereal, cerealVariedad) {
  return dispatch => {
    const promesaEtiqueta = getListaDeEtiquetas(cereal, cerealVariedad)
    const callback = (etiquetaDataPromise) => {
      dispatch({
        type: 'UPDATE_ETIQUETAS_DROPDOWN',
        etiquetas: etiquetaDataPromise['filas'] || []
      })
    }
    promesaEtiqueta.then(callback)
  }
}
